import script from "./UiAlert.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiAlert.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiAlert.vue?vue&type=script&setup=true&lang=ts"

import "./UiAlert.vue.scss?vue&type=style&index=0&id=cab343db&lang=scss!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiAlert.vue?vue&type=style&index=0&id=cab343db&lang=scss"

const __exports__ = script;

export default __exports__